var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2571 15.6109C19.2805 16.0008 19.6876 16.2638 20.0184 16.0562C22.0738 14.7667 23.4402 12.4804 23.4402 9.87504C23.4402 5.84796 20.1757 2.58337 16.1486 2.58337C13.5432 2.58337 11.2569 3.94984 9.96742 6.00518C9.75986 6.33602 10.0228 6.74307 10.4127 6.76651C15.075 7.0468 18.9767 10.9526 19.2571 15.6109Z",
    fill: "#f8780c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1908 16.125C17.1908 20.1521 13.9262 23.4167 9.89909 23.4167C5.87201 23.4167 2.60742 20.1521 2.60742 16.125C2.60742 12.098 5.87201 8.83337 9.89909 8.83337C13.9262 8.83337 17.1908 12.098 17.1908 16.125Z",
    fill: "#f8780c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCoins);
export default __webpack_public_path__ + "static/media/copy-coins.ff3b51cc7cb0897133b7a89e231b9d0f.svg";
export { ForwardRef as ReactComponent };